"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Prebinding_1 = require("../../base/Prebinding");
var coveo_search_ui_1 = require("coveo-search-ui");
var externalComponentsOption = "externalComponents";
var SearchInterfaceComponentInitializer = (function () {
    function SearchInterfaceComponentInitializer() {
    }
    SearchInterfaceComponentInitializer.prototype.loadComponentsForSearchInterface = function (searchInterface, newComponent) {
        Prebinding_1.Prebinding.applyPrebindingOnElement(newComponent);
        Prebinding_1.Prebinding.applyPrebindingOnChildren(newComponent);
        var result = Coveo.Initialization.automaticallyCreateComponentsInside(newComponent, {
            bindings: searchInterface.getBindings(),
            options: {}
        });
        return result.initResult.then(function () {
            searchInterface.queryController.executeQuery({
                ignoreWarningSearchEvent: true
            });
        });
    };
    SearchInterfaceComponentInitializer.prototype.loadComponentsWithSearchInterfaceInitialization = function (searchInterfaceElement, element) {
        var _this = this;
        coveo_search_ui_1.$$(searchInterfaceElement).on(coveo_search_ui_1.InitializationEvents.beforeInitialization, function () {
            var searchInterfaceComponent = coveo_search_ui_1.get(searchInterfaceElement, coveo_search_ui_1.SearchInterface);
            _this.pushElementInSearchInterfaceExternalComponents(searchInterfaceComponent, element);
        });
    };
    SearchInterfaceComponentInitializer.prototype.pushElementInSearchInterfaceExternalComponents = function (searchInterfaceComponent, element) {
        if (!searchInterfaceComponent.options[externalComponentsOption]) {
            searchInterfaceComponent.options[externalComponentsOption] = [];
        }
        searchInterfaceComponent.options[externalComponentsOption].push(element);
    };
    return SearchInterfaceComponentInitializer;
}());
exports.SearchInterfaceComponentInitializer = SearchInterfaceComponentInitializer;
var initializer = new SearchInterfaceComponentInitializer();
function getInitializerInstance() {
    return initializer;
}
exports.getInitializerInstance = getInitializerInstance;



//////////////////
// WEBPACK FOOTER
// ./src/resolvers/components/SearchInterfaceComponentInitializer.ts
// module id = 10
// module chunks = 13 14